module.exports = __webpack_public_path__ + "static/media/KaWineAndDine_Badge.c96b6d38.jpg";